import axios from 'axios'
import URI from 'urijs'
import TmpFileService from './TmpFileService'

import { uuid, localStorage, compressFile, isMinioUpload } from '../utils/basicUtil'
export function uploadService (file, functionPoint, blob = false, isNoAuthUpload = false, noAuthParams, options = {}) {
  /**
   *
   * @param file upload file
   * @param functionPoint upload function
   * @param blob upload blob
   * @param isNoAuthUpload 是否是无权限上传
   * @param noAuthParams 无权限上传相关参数
   * @return Promise<any>
   */
  const fileName = uuid()
  const getFileUrl = async (item) => {
    let i = ''
    await new Promise(async (resolve) => {
      const fileData = await TmpFileService.getFile2(item)
      if (fileData.success) {
        i = fileData.url
        resolve(true)
      }
    })
    return i
  }
  return new Promise(async (resolve, reject) => {
    try {
      let fileType = ''
      let originFileName = ''
      if (!blob) {
        fileType = file.name.substr(file.name.lastIndexOf('.'))
        originFileName = file.name.substring(0, file.name.lastIndexOf('.'))
      } else {
        fileType = file.type.substr(file.type.lastIndexOf('/'))
        originFileName = uuid()
      }
      const signatureFunctionPoint = options.signatureFunctionPoint || 'mobilecompany'
      const autoProcess = options.autoProcess !== false
      let result = {}
      if (isNoAuthUpload) { // 是否是无权限上传
        result = await axios.post(`/api/v2/agent/oss/get-signature-notoken`, { objectName: `${fileName}${fileType}`, fileName, functionPoint: signatureFunctionPoint, companyId: noAuthParams.companyId })
      } else {
        result = await axios.post(`/api/v2/bud/oss/get-signature`, { objectName: `${fileName}${fileType}`, fileName, functionPoint: signatureFunctionPoint }, { headers: { 'X-Access-Token': localStorage.get('X-Access-Token') } })
      }
      const { data } = result
      if (data.code !== '200') {
        reject(new Error('上传服务出错'))
      } else {
        if (data.data) {
          if (isMinioUpload()) {
            // 兼容minio逻辑
            const minioData = data.data
            const ossHost = minioData.host

            // const functionUrl = minioData.fileProcessUrl
            // const fileDirectory = data.data.fileDirectory

            // const originFileName = file.name.substring(0, file.name.lastIndexOf('.'))
            const newOssHost = ossHost
            const ossData = await axios.put(newOssHost, file, { headers: { 'X-Access-Token': localStorage.get('X-Access-Token'), 'X-C-Token': localStorage.get('X-C-Token') } })
            if (ossData.status === 200) {
              let url = ''
              if (minioData.fileDirectory) {
                if (!(minioData.fileDirectory.indexOf('http') > -1)) {
                  const res = await getFileUrl(minioData.fileDirectory)
                  url = res.replace('/minioProd/test', '/test')
                }
              } else {
                url = minioData.fileDirectory
              }
              const responseData = {
                code: '200',
                success: true,
                fileName: `${fileName}${fileType}`,
                originFileName: `${originFileName}${fileType}`,
                fileDirectory: minioData.fileDirectory,
                fileUrl: url,
                file: {
                  name: `${file.name}`
                }
              }
              resolve(responseData)
            }
          } else {
            let formData = new FormData()
            let fileDirectory = data.data.fileDirectory
            // let fileType = file.name.substr(file.name.lastIndexOf('.'))

            let functionUrl = data.data.fileProcessUrl

            data.data.key = `${fileDirectory}${fileName}${fileType}`
            data.data.Filename = `${fileDirectory}${fileName}${fileType}`
            data.data.OSSAccessKeyId = data.data.accessId
            for (let key in data.data) {
              formData.append(key, data.data[key])
            }
            compressFile(file, async (res) => {
              formData.append('success_action_status', '200')
              formData.append('file', res)
              let url = new URI(data.data.host).hostname()
              let host = `${window.location.protocol}//${url}`
              const ossData = await axios.post(host, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              if (ossData.status === 200) {
                let reqData = {
                  functionPoint,
                  fileName: `${fileName}${fileType}`,
                  originFileName: `${originFileName}${fileType}`,
                  fileDirectory: `${fileDirectory}`
                }
                if (functionUrl && autoProcess) {
                  const result = await this.$http.post(functionUrl, reqData, { headers: { 'X-Access-Token': localStorage.get('X-Access-Token') } })
                  resolve(result.data)
                } else {
                  const responseData = {
                    code: '200',
                    success: true,
                    fileName: `${fileName}${fileType}`,
                    originFileName: `${originFileName}${fileType}`,
                    fileDirectory,
                    fileUrl: `${host}/${fileDirectory}${fileName}${fileType}`,
                    file: {
                      name: `${file.name}`
                    }
                  }
                  resolve(responseData)
                }
              } else {
                reject(new Error('上传服务出错'))
              }
            })
          }
        } else {
          reject(new Error('上传服务出错'))
        }
      }
    } catch (e) {
      reject(e)
    }
  })
}

export default uploadService
